import { formatInstantAsZonedDate, formatInstantAsZonedTime12h } from 'utils/i18n-format-date';

export type NormalizedOpenHouseFields = {
  date: string | null;
  from: string | null;
  to: string | null;
  timezone: string | null;
};

export function normalizeClientAppOpenHouse(openHouse: Record<string, unknown>): NormalizedOpenHouseFields {
  return {
    date: (openHouse.date as string | null) ?? null,
    from: (openHouse.from as string | null) ?? null,
    to: (openHouse.to as string | null) ?? null,
    timezone: (openHouse.timezone as string | null) ?? null,
  };
}

type TimestampLike = Date | { toDate: () => Date } | null | undefined;

export function normalizeGoSearchOpenHouse(openHouse: {
  from?: TimestampLike;
  to?: TimestampLike;
  timezone?: string | null;
}): NormalizedOpenHouseFields {
  const zone = openHouse.timezone || null;
  const fromInstant = toDate(openHouse.from);
  const toInstant = toDate(openHouse.to);

  if (zone && fromInstant) {
    return {
      from: formatInstantAsZonedTime12h(fromInstant, zone),
      to: toInstant ? formatInstantAsZonedTime12h(toInstant, zone) : null,
      date: formatInstantAsZonedDate(fromInstant, zone),
      timezone: zone,
    };
  }

  return {
    from: fromInstant ? renderUtcWallClockTime(fromInstant) : null,
    to: toInstant ? renderUtcWallClockTime(toInstant) : null,
    date: fromInstant?.toISOString() ?? null,
    timezone: null,
  };
}

function toDate(ts: TimestampLike): Date | null {
  if (!ts) return null;
  return ts instanceof Date ? ts : ts.toDate();
}

function renderUtcWallClockTime(instant: Date): string {
  let hours = instant.getUTCHours();
  const minutes = instant.getUTCMinutes();
  const period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${hours}:${String(minutes).padStart(2, '0')}${period}`;
}
